module.exports = __webpack_public_path__ + "static/media/loadinggif.8f6d93bc.gif";